// ZoneModule.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';
import map from '../../../../assets/icons/google_map.svg'
import { updateZoneLeader, updateZoneExecutive, getPositionUnit } from '../integracion';
import Swal from 'sweetalert2';
import axios from 'axios';
const urlWialon = process.env.REACT_APP_WIALON_URL_UNIT


function ZoneModule({
    zoneName,
    zoneData,
    leadersOptions,
    executivesOptions,
    clientsInZone,
    unitsInZone,
    onReassignItem,
    onLeaderExecutiveUpdate,
    zonesOptions,
    zoneDescription
}) {
    const currentLeader = zoneData?.lider || null;
    const currentExecutive = zoneData?.ejecutivo || null;

    const [isLeaderEditing, setIsLeaderEditing] = useState(false);
    const [isExecutiveEditing, setIsExecutiveEditing] = useState(false);

    const [displayReassignDialog, setDisplayReassignDialog] = useState(false);
    const [itemToReassign, setItemToReassign] = useState(null);
    const [reassignType, setReassignType] = useState('');
    const [selectedNewZone, setSelectedNewZone] = useState(null);
    const [position, setPosition] = useState(null);

    const opClients = useRef(null);
    const opUnits = useRef(null);

    const handleLeaderChange = async (newLeader) => {
        setIsLeaderEditing(false);
        try {
            const previousLeaderId = currentLeader ? currentLeader.code : 'N/A';
            const newLeaderId = newLeader.code;
            const params = {
                id_leater_after: newLeaderId,
                zone: zoneData.idZona
            };
            console.log(`Intentando cambiar líder en Zona ${zoneName}: de ${previousLeaderId} a ${newLeaderId}`);
            await updateZoneLeader(params);
            onLeaderExecutiveUpdate();

        } catch (error) {
            console.error(`Fallo al actualizar el líder para ${zoneName}:`, error);
        }
    };

    const handleExecutiveChange = async (newExecutive) => {
        setIsExecutiveEditing(false);
        console.log("newExecutive", newExecutive);

        try {
            const previousExecutiveId = currentExecutive ? currentExecutive.code : 'N/A';
            const newExecutiveId = newExecutive.code;
            const params = {
                id_executive_after: newExecutiveId,
                zone: zoneData.idZona
            };
            console.log(`Intentando cambiar ejecutivo en Zona ${zoneName}: de ${previousExecutiveId} a ${newExecutiveId}`);
            await updateZoneExecutive(params); // Descomentar y usar tu API real cuando esté lista

            onLeaderExecutiveUpdate();

        } catch (error) {
            console.error(`Fallo al actualizar el ejecutivo para ${zoneName}:`, error);
        }
    };

    const getStatusSeverity = (status) => {
        switch (status) {
            case 'Activo':
            case 'En Servicio':
            case 'En Ruta':
                return 'success';
            case 'En Reparación':
            case 'Inactivo':
                return 'warning';
            default:
                return null;
        }
    };

    const openReassignDialog = (item, type) => {
        setItemToReassign(item);
        setReassignType(type);
        setSelectedNewZone(null);
        setDisplayReassignDialog(true);
    };

    const handleReassign = async () => {
        if (itemToReassign && selectedNewZone) {
            console.log("itemToReassign", itemToReassign);
            console.log("selectedNewZone", selectedNewZone);

            console.log(`Confirmando reasignación de ${reassignType} ${itemToReassign.ID || itemToReassign.NOMBRE_CLIENTE || itemToReassign.TIPO} de ${zoneName} a ${selectedNewZone}`);
            if (reassignType == 'client') {
                await onReassignItem(itemToReassign, reassignType, itemToReassign.ID_CLIENTE, selectedNewZone?.code);
            }
            else {
                await onReassignItem(itemToReassign, reassignType, itemToReassign.ID, selectedNewZone?.code);
            }

            setDisplayReassignDialog(false);
            setItemToReassign(null);
            setReassignType('');
            setSelectedNewZone(null);
        }
    };

    const actionBodyTemplate = (rowData, type) => {
        return (
            <Button
                icon="pi pi-pencil"
                className="p-button-sm p-button-text p-button-primary"
                onClick={() => openReassignDialog(rowData, type)}
            />
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <Tag
                value={rowData.ESTATUS}
                severity={getStatusSeverity(rowData.ESTATUS)}
            />
        );
    };

    const reassignDialogFooter = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setDisplayReassignDialog(false)} className="p-button-text" />
            <Button label="Reasignar" icon="pi pi-check" onClick={handleReassign} autoFocus disabled={!selectedNewZone} />
        </div>
    );

    const showMap = async (rowData) => {
        const data = await getPositionUnit(rowData.ID, setPosition)
        console.log("pos", data);
        if (data) {
            const googleMapsUrl = `https://www.google.com/maps?q=${data.lat},${data.lng}`;
            window.open(googleMapsUrl, '_blank');
        } else {
            Swal.fire({
                icon: "error",
                text: 'Coordenadas inválidas',

            });
        }

    };

    const actionBodyTemplatePositionInMap = (rowData) => {

        return(
        <>
            <Button icon={<img src={map} alt="list" width="20px" />}
                rounded text onClick={() => { showMap(rowData) }}></Button>

        </>)
    };
    const titleTemplate = ()=>
    {
        return(
            <>
                <div className='conatiner-items-title'>
                    {zoneName}
                    <div className="description">
                        {zoneData?.descripcion}
                    </div>
                </div>
            </>
        )
        
    }
    console.log("clientsInZone",clientsInZone);
    

    return (
        <Card title={titleTemplate} className="zone-module-card">
            <div className="zone-card-content">
                <div className="role-management">
                    <div className="role-field">
                        <div className='input-group'>
                            <label htmlFor={`${zoneName.toLowerCase()}-leader-dropdown`} className="p-text-bold">Líder:</label>
                            <Dropdown
                                id={`${zoneName.toLowerCase()}-leader-dropdown`}
                                value={currentLeader}
                                options={leadersOptions}
                                onChange={(e) => handleLeaderChange(e.value)}
                                placeholder="Selecciona un líder"
                                disabled={!isLeaderEditing}
                                className="p-inputtext-sm p-fluid"
                                optionLabel="name"
                                valueTemplate={(option, props) => {
                                    if (option) {
                                        return <div>{option.name}</div>;
                                    }
                                    return props.placeholder;
                                }}
                                itemTemplate={(option) => <div>{option.name}</div>}
                            />
                        </div>
                        <Button
                            icon={isLeaderEditing ? "pi pi-lock-open" : "pi pi-lock"}
                            className="p-button-rounded p-button-text p-button-sm p-ml-1"
                            onClick={() => setIsLeaderEditing(!isLeaderEditing)}
                        />
                    </div>
                    <div className="role-field">
                        <div className='input-group'>
                            <label htmlFor={`${zoneName.toLowerCase()}-executive-dropdown`} className="p-text-bold">Ejecutivo de Cuenta:</label>
                            <Dropdown
                                id={`${zoneName.toLowerCase()}-executive-dropdown`}
                                value={currentExecutive}
                                options={executivesOptions}
                                onChange={(e) => handleExecutiveChange(e.value)}
                                placeholder="Selecciona un ejecutivo"
                                disabled={!isExecutiveEditing}
                                className="p-inputtext-sm p-fluid"
                                optionLabel="name"
                                valueTemplate={(option, props) => {
                                    if (option) {
                                        return <div>{option.name}</div>;
                                    }
                                    return props.placeholder;
                                }}
                                itemTemplate={(option) => <div>{option.name}</div>}
                            />
                        </div>
                        <Button
                            icon={isExecutiveEditing ? "pi pi-lock-open" : "pi pi-lock"}
                            className="p-button-rounded p-button-text p-button-sm p-ml-1"
                            onClick={() => setIsExecutiveEditing(!isExecutiveEditing)}
                        />
                    </div>
                </div>

                <div className="p-d-flex p-jc-evenly p-mt-3">
                    <Button
                        label="Ver Clientes"
                        icon="pi pi-users"
                        className="p-button-sm p-button-secondary p-button-outlined"
                        onClick={(e) => opClients.current && opClients.current.toggle(e)}
                    />
                    <Button
                        label="Ver Unidades"
                        icon="pi pi-truck"
                        className="p-button-sm p-button-secondary p-button-outlined p-ml-2"
                        onClick={(e) => opUnits.current && opUnits.current.toggle(e)}
                    />
                </div>

                <OverlayPanel ref={opClients} showCloseIcon>
                    <div className="overlay-panel-content">
                        <h4>Clientes de {zoneName}</h4>
                        <DataTable
                            value={clientsInZone}
                            scrollable
                            scrollHeight="300px"
                            className="p-datatable-responsive p-mt-2"
                            emptyMessage="No hay clientes en esta zona."
                        >
                            <Column field="ID_CLIENTE" header="ID" style={{ width: '80px' }}></Column>
                            <Column field="NOMBRE_CLIENTE" header="Nombre" style={{ minWidth: '150px' }}></Column>
                            <Column field="CLASIFICACION" header="Clasificación" style={{ minWidth: '120px' }}></Column>
                            <Column field="TOTAL_RUTAS" header="Rutas" style={{ width: '80px' }}></Column>
                            <Column body={(rowData) => actionBodyTemplate(rowData, 'client')} header="Acción" style={{ width: '80px', flexShrink: 0 }}></Column>
                        </DataTable>
                    </div>
                </OverlayPanel>

                <OverlayPanel ref={opUnits} showCloseIcon>
                    <div className="overlay-panel-content">
                        <h4>Unidades de {zoneName}</h4>
                        <DataTable
                            value={unitsInZone}
                            scrollable
                            scrollHeight="300px"
                            className="p-datatable-responsive p-mt-2"
                            emptyMessage="No hay unidades en esta zona."
                        >
                            <Column field="ID" header="ID" style={{ width: '80px' }}></Column>
                            <Column field="TIPO" header="Tipo" style={{ minWidth: '150px' }}></Column>
                            <Column field="ubicacion" header="Ubicación" style={{ minWidth: '150px' }} body={actionBodyTemplatePositionInMap}></Column>
                            <Column field="ESTATUS" header="Estatus" body={statusBodyTemplate} style={{ width: '120px' }}></Column>
                            <Column body={(rowData) => actionBodyTemplate(rowData, 'unit')} header="Acción" style={{ width: '80px', flexShrink: 0 }}></Column>
                        </DataTable>
                    </div>
                </OverlayPanel>

                <Dialog
                    header={`Reasignar ${reassignType === 'client' ? 'Cliente' : 'Unidad'}: ${itemToReassign ? (itemToReassign.NOMBRE_CLIENTE || itemToReassign.TIPO || itemToReassign.ID) : ''}`}
                    visible={displayReassignDialog}
                    onHide={() => setDisplayReassignDialog(false)}
                    footer={reassignDialogFooter}
                    style={{ width: '60vw' }}
                    breakpoints={{ '960px': '80vw', '641px': '90vw' }}
                >
                    <div className="p-fluid">
                        <div className="p-field p-mt-3">
                            <label htmlFor="new-zone-dropdown">Transferir a la zona:</label>
                            <Dropdown
                                id="new-zone-dropdown"
                                value={selectedNewZone}
                                options={zonesOptions}
                                onChange={(e) => setSelectedNewZone(e.value)}
                                optionLabel='name'
                                placeholder="Selecciona una zona"
                            />
                        </div>
                    </div>
                </Dialog>
            </div >
        </Card >
    );
}

export default ZoneModule;